export default __webpack_public_path__ + "static/media/flicker-on.27a82721.gif";